import React, { useState } from "react";
import { Cor, DadoPesquisaCor, FiltroPesquisaCor } from "app/api/classes/ProdutoApi";
import { useFormik } from "formik";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
const estiloPesquisarCor = require("./pesquisa-cor.module.scss").default;

export type PesquisaCorTintaProps = {
  tintometricoSimplificado: boolean
  cores: DadoPesquisaCor;
  filtro: FiltroPesquisaCor;
  corFundoSelecionado: string;
  corTextoSelecionado: string;
  onPesquisar: (filtro: FiltroPesquisaCor) => void;
  onClickSelecionado: (corSelecionada: Cor) => void;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
};

const PesquisaCorTinta = (props: PesquisaCorTintaProps) => {
  

  const formik = useFormik({
    initialValues: { ...props.filtro },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const formularioPesquisa = <>
    <form id="form-selecionar-cor">
      <fieldset className={estiloPesquisarCor.separador}>
        <div className={estiloPesquisarCor.divForm}>
          <label>{props.tintometricoSimplificado ? "Código da Cor" : "Código da Cor do Fabricante"}</label>
          <input
            name="CodigoCorFabricante"
            id="CodigoCorFabricante"
            type="text"
            maxLength={254}
            value={(formik.values.CodigoCorFabricante) ?? ""}
            onChange={formik.handleChange}
          />
        </div>
        <div className={estiloPesquisarCor.divForm}>
          <label>{props.tintometricoSimplificado ? "Nome da Cor" : "Descrição da Cor"}</label>
          <input
            name="DescricaoCor"
            type="text"
            value={(formik.values.DescricaoCor) ?? ""}
            onChange={formik.handleChange}
          />
        </div>
      </fieldset>
    </form>
    <div>
      <button
        className={estiloPesquisarCor.botao}
        onClick={() => {
          props.onPesquisar(formik.values);
        }}
      >
        Pesquisar
      </button>
    </div>
  </>

  const tabela = () => {

    const head = <div>
      <div>Código da Cor</div>
      {!props.tintometricoSimplificado &&
        <div>{props.cores?.Legenda}</div>
      }
      <div>{props.tintometricoSimplificado ? "Nome da Cor" : "Descrição da Cor"}</div>
    </div>

    const corpo = props.cores?.CoresProduto?.Entities?.map((cor) => {
      
      return (
        <div
          key={cor.Codigo}
          style={
            cor.Codigo == corSelecionada?.Codigo
              ? {
                backgroundColor: props.corFundoSelecionado,
                color: props.corTextoSelecionado,
              }
              : {}
          }
          className={
            cor.Codigo == corSelecionada?.Codigo
              ? estiloPesquisarCor.linhaSelecionada
              : estiloPesquisarCor.linha
          }
          onClick={() => {
            cor.Codigo == corSelecionada?.Codigo
            setCorSelecionada(cor)
          }}
        >
          <div>{cor.CodigoExterno}</div>
          {!props.tintometricoSimplificado &&
            <div>{cor.CodigoExterno2}</div>
          }
          <div>{cor.Nome}</div>
        </div>
      );
    })

    const paginacao = props.cores?.CoresProduto?.PageCount > 1 && (
      <>
        <br />
        <Paginacao
          paginaAtual={props.cores?.CoresProduto?.ActualPage}
          totalPaginas={props.cores?.CoresProduto?.PageCount}
          onAlterarListaSelecionada={props.onAlterarListaSelecionada}
          id="PesquisaCorTinta_Paginacao"
        />
        <br />
      </>
    )

    const botoes = <div>
      <button
        style={
          corSelecionada != null
            ? { backgroundColor: "#409fff" }
            : { backgroundColor: "var(--mu-superficie-sutil, #f1f2f2)", color: "var(--mu-texto, #000)" }
        }
        onClick={() => {
          props.onClickSelecionado(corSelecionada);
        }}
        className={estiloPesquisarCor.botao}
      >
        OK
      </button>
      <br />
    </div>

    return props.cores?.CoresProduto?.Entities?.length > 0 && (
      <>
        {botoes}
        <div id="tabela-fornecedores" className={estiloPesquisarCor.tabela}>
          {head}

          {corpo}
        </div>

        {paginacao}

        {botoes}
      </>
    )
  }

  const [corSelecionada, setCorSelecionada] = useState<Cor>(null)
  return (
    <>
      {formularioPesquisa}

      {tabela()}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};

export { PesquisaCorTinta };
